(() => {
  if (window.OztechMotion) return;

  const selector =
    '.oz-section .oz-heading, .oz-section .oz-eyebrow, .oz-section .oz-copy, .oz-section .oz-card, .oz-section .oz-media';

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('oz-in-view');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      )
    : null;

  const itemsWithin = (root) => {
    const items = [];
    if (root instanceof Element && root.matches(selector)) items.push(root);
    root.querySelectorAll?.(selector).forEach((item) => items.push(item));
    return items;
  };

  const isInInitialViewport = (item) => {
    const rect = item.getBoundingClientRect();
    return rect.bottom >= 0 && rect.top <= window.innerHeight;
  };

  const init = (root = document) => {
    itemsWithin(root).forEach((item, index) => {
      if (item.dataset.ozMotionInitialized === 'true') return;
      item.dataset.ozMotionInitialized = 'true';
      item.style.setProperty('--oz-delay', `${Math.min(index % 4, 3) * 70}ms`);

      if (window.Shopify?.designMode || !observer || isInInitialViewport(item)) {
        // Add both classes in one mutation so content already visible at first paint is never
        // hidden by the reveal CSS after DOMContentLoaded.
        item.classList.add('oz-reveal', 'oz-in-view');
      } else if (observer) {
        item.classList.add('oz-reveal');
        observer.observe(item);
      }
    });
  };

  const destroy = (root) => {
    itemsWithin(root).forEach((item) => observer?.unobserve(item));
  };

  window.OztechMotion = { init, destroy };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();
